<script lang="ts">
	import { main_colors, translateDynKey, translateFilterName } from '$lib';
	import { getContext } from 'svelte';
	import { slide } from 'svelte/transition';

	import type { FilterProvider, TermsFilter } from './store.svelte';

	import FilterDrawer from './FilterDrawer.svelte';

	const { filter }: { filter: TermsFilter } = $props();

	let isOpen = $state(false);

	const filterProvider = getContext<FilterProvider>('filter');
	const selectedValuesCount = $derived(filterProvider.getSelectedCount(filter.name));

	const orderedValues = $derived(
		[...filter.values].sort((a, b) => {
			const aChecked = filterProvider.isChecked(filter.name, a.value);
			const bChecked = filterProvider.isChecked(filter.name, b.value);
			if (aChecked !== bChecked) return aChecked ? -1 : 1;
			return 0;
		}),
	);
</script>

{#if filter.values.length > 1}
	{#snippet icon()}
		<span class={['icon-[mdi--chevron-down] transition', { 'rotate-180': isOpen }]}></span>
	{/snippet}

	{#snippet selected()}
		<div class="flex flex-row flex-wrap gap-1">
			{#each filter.values.filter( (v) => filterProvider.checkedFilters[filter.name].includes(v.value), ) as value (value)}
				{@const color = main_colors[value.value] ?? '#FFFFFF'}
				<div class="flex items-center gap-1">
					<!-- eslint-disable-next-line custom-rules/no-inline-styles -->
					<span class={['size-4 rounded border border-neutral-300']} style="background: {color}"
					></span>
					<span>
						{translateDynKey(`main_colors.${value.value}`)}
					</span>
				</div>
			{/each}
		</div>
	{/snippet}

	<FilterDrawer
		name={translateFilterName(filter.name)}
		{icon}
		onclick={() => (isOpen = !isOpen)}
		selected={!isOpen && selectedValuesCount > 0 ? selected : undefined}
	>
		{#if isOpen}
			<div transition:slide class="flex flex-col divide-y divide-neutral-300 py-2">
				{#each orderedValues as value (value.value)}
					{@const color = main_colors[value.value] ?? '#FFFFFF'}
					<label
						class={[
							'flex cursor-pointer items-center justify-between py-1 pr-4 pl-2 transition-colors hover:bg-neutral-100',
							{
								'bg-neutral-200! hover:bg-neutral-300!': filterProvider.isChecked(
									filter.name,
									value.value,
								),
							},
						]}
					>
						<div class="flex items-center gap-2 capitalize">
							<!-- eslint-disable custom-rules/no-inline-styles -->
							<button
								style="background: {color}"
								class="relative size-6 cursor-pointer items-center gap-2 rounded border border-neutral-300"
								title={value.value}
								aria-label={value.value}
								onclick={() => filterProvider.toggle(filter.name, value.value)}
							>
								{#if filterProvider.isChecked(filter.name, value.value)}
									<span
										style="color: {color}; filter: invert(1) grayscale(1) brightness(1.3) contrast(9000);"
										class={[
											'icon-[mdi--check] absolute top-1/2 left-1/2 -translate-1/2 opacity-95 mix-blend-luminosity',
											{
												'text-white!': value.value === 'MULTICOLOR',
											},
										]}
									></span>
									<!-- eslint-enable custom-rules/no-inline-styles -->
								{/if}
							</button>
							{translateDynKey(`main_colors.${value.value}`)}
						</div>
						<div>{value.count}</div>
					</label>
				{/each}
			</div>
		{/if}
	</FilterDrawer>
{/if}
